import styled from 'styled-components'


export const DashboardMenuContainer = styled.div.attrs({
})`
    width: 350px;
`;

export const DashboardMenu = styled.div.attrs({
    className: 'menu-contant'
})`
    max-width: 389px;
    background: ${props => props.theme.palette.darkPrimary.main};
    width: 100%;
    min-height: calc(100vh - 60px);
    max-height: calc(100vh - 60px);
    display: flex;
    flex-direction: column;
    overflow: auto;
`;

export const DashboardMenuHeader = styled.div.attrs({
})`           
    height: 60px;
    width: 100%; 
    display: flex;
    align-items: center;
    padding: 0 20px;

    
    font-size: 15px;
    color: ${props => props.theme.palette.colors.white};
    border-top: 1px solid ${props => props.theme.palette.colors.grey};
    border-bottom: 1px solid ${props => props.theme.palette.colors.grey};
    cursor: pointer;

    background: ${props => props.theme.palette.darkPrimary.main};
    background: linear-gradient(48deg, rgba(${props => props.theme.palette.darkPrimary.main},1) 0%, rgba(${props => props.theme.palette.darkPrimary.main},.9) 21%, rgba(${props => props.theme.palette.primary.main},.75) 49%, rgba(${props => props.theme.palette.primary.main},.6) 87%, rgba(${props => props.theme.palette.primary.main},.45) 100%);
`;

export const DashboardMenuHeaderIcon = styled.img.attrs({
})`           
    width: 32px;
    height: 32px;
    border-radius: 16px;
    margin-right: 20px;
    cursor: pointer;
`;

export const DashboardMenuHeaderUserContent = styled.div.attrs({
})`           
    padding: 27px 25px;
    margin-bottom: 28px;
    background: ${props => props.theme.palette.primary.main} ;
`;

export const DashboardMenuHeaderUserImage = styled.div.attrs({
})`           
    width: 160px;
    height: 160px; 
    border-radius: 80px; 
    background: ${props => props.theme.palette.colors.grey} url(/logo1024.png) no-repeat center center / cover;
    margin: 0 auto 12px;
    overflow: hidden;
`;

export const DashboardMenuHeaderUserText = styled.div.attrs({
})`           
    font-size: 15px;
    font-weight: bold;
    color: ${props => props.theme.palette.colors.white};
    margin-bottom: 12px; 
`;

export const DashboardMenuOption = styled.div.attrs({
})`           
    padding: 10px 13px;
    margin: 23px 16px 6px;
    font-size: 16px;
    border-radius: 10px;
    color: ${props => props.theme.palette.colors.white};
    
    display: flex;
    
    cursor: pointer; 
    &:hover{
        text-decoration: underline;
    }
    
    ${props => props.active ? `
            background: ${props.theme.palette.colors.blue};
            font-weight: bold;
            color: ${props.theme.palette.colors.yellow};
        ` : ``
    }
`;


export const DashboardMenuContent = styled.div.attrs({
})` 
    flex:1;
`;

export const DashboardMenuFooter = styled.div.attrs({
})`
    padding: 20px;
`;

export const DashboardVersionContent = styled.div.attrs({
})` 
    margin: 24px 0;
`;

export const DashboardVersionText = styled.div.attrs({
})`
    font-size: 15px;
    font-weight: bolder;
    color: ${props => props.theme.palette.colors.white};
    text-align: center; 
`;




export const DashboardMenuOptionIcon = styled.img.attrs(props => ({
    src: `/icons/${props.icon}${props.active ? `-on` : `-off`}.svg`,
    width: props.big ? 24 : 18,
}))`
 margin: ${props => props.big ? `0 -3px` : `0`};
`;

export const DashboardMenuOptionText = styled.div.attrs({
})`
    flex: 1;
    padding: 0 12px;
`;

export const DashboardMenuOptionChevron = styled.img.attrs(props => ({
    src: `/icons/chevron${props.active ? `-on` : `-off`}.svg`,
}))`
`;




export const DashboardMenuOptionContent = styled.div.attrs({
})`
`;

export const DashboardMenuOptionSuboptions = styled.div.attrs({
})`
    border-left: 2px solid ${props => props.theme.palette.colors.blue};
    margin-left: 36px;
    padding-left: 10px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const DashboardMenuOptionSuboptionsOption = styled.div.attrs({
})`
    color: ${props => props.theme.palette.colors.white};
    padding: 5px 10px;
    margin: 5px 0;
    border-radius: 12px;
    
    cursor: pointer; 
    &:hover{
        text-decoration: underline;
    }
    
    ${props => props.active ? `
            background: ${props.theme.palette.colors.blue};
            font-weight: bolder;
            color: ${props.theme.palette.colors.yellow};
        ` : ``
    }
`;